import PropTypes from 'prop-types';
import React from 'react'
import Dropzone from 'react-dropzone'


export default class extends React.Component {
    static propTypes = {
		profile_picture: PropTypes.string,
		editing_fields: PropTypes.bool,
		addUpdateField: PropTypes.func.isRequired,
		removeUpdateField: PropTypes.func.isRequired
	};

    state = {
        new_profile_picture: {}
    };

    openImageSelect = () => {
		this.refs.dropzone.open()
	};

    selectImage = (files) => {
		this.props.addUpdateField('profile_picture', 'image', files[0])
		this.setState({ 
			'new_profile_picture': files[0]
		})
	};

    cancelUpload = () => {
		this.props.removeUpdateField('profile_picture', 'image')
		this.setState({ 
			'new_profile_picture': {}
		})
	};

    render() {

		var profileImage = 'preview' in this.state.new_profile_picture ? this.state.new_profile_picture.preview : this.props.profile_picture,
			style = { backgroundImage: 'url(' + profileImage + ')' };

		return (
			<div> 
	    		<div id="edit_profile_picture">

					<div className="profile-image" style={style}>
						{ !profileImage && <i className="fa fa-clock text-black"></i> }
					</div>

					{ this.props.editing_fields &&
						<div className="dropzone">
							<Dropzone onDrop={this.selectImage} multiple={false} disableClick={true} accept={'image/*'} ref="dropzone">
								<div onClick={this.openImageSelect}>
									<p className="edit-icon"><i className="fa fa-cloud-upload text-white"></i></p>
								</div>
				            </Dropzone>
			            </div>
			        }

	            </div>

            	{ this.props.editing_fields && this.state.profile_picture &&
					<button className="btn btn-danger" onClick={this.cancelUpload}>
						<i className="fa fa-close text-mid-danger"></i>
					</button>
				}

			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Profile/components/Header/components/ProfileImage.jsx